var map = {
	"./am.json": 60091,
	"./ar.json": 5310,
	"./az.json": 29686,
	"./bg.json": 44378,
	"./bn.json": 57581,
	"./bs.json": 2086,
	"./ceb.json": 91697,
	"./cs.json": 83571,
	"./da.json": 49914,
	"./de.json": 95894,
	"./el.json": 94524,
	"./en.json": 44174,
	"./es.json": 46725,
	"./et.json": 16004,
	"./fa.json": 93248,
	"./fi.json": 46808,
	"./fr.json": 94605,
	"./hi.json": 53134,
	"./hr.json": 36759,
	"./hu.json": 86938,
	"./hy.json": 4638,
	"./id.json": 35176,
	"./ig.json": 10981,
	"./is.json": 90433,
	"./it.json": 83672,
	"./ja.json": 87980,
	"./jw.json": 87922,
	"./ka.json": 19173,
	"./kk.json": 27699,
	"./km.json": 60089,
	"./ko.json": 19423,
	"./ku.json": 68001,
	"./lt.json": 65449,
	"./lv.json": 21103,
	"./mg.json": 61161,
	"./mk.json": 14165,
	"./ml.json": 68308,
	"./mr.json": 85090,
	"./ms.json": 24525,
	"./my.json": 7243,
	"./ne.json": 40484,
	"./nl.json": 34943,
	"./no.json": 77086,
	"./ny.json": 73888,
	"./pa.json": 98190,
	"./pl.json": 11029,
	"./ps.json": 66860,
	"./pt.json": 37741,
	"./ro.json": 22354,
	"./ru.json": 74600,
	"./sd.json": 12734,
	"./si.json": 13701,
	"./sk.json": 10347,
	"./sl.json": 37110,
	"./so.json": 68151,
	"./sq.json": 98141,
	"./sr.json": 78912,
	"./su.json": 78665,
	"./sv.json": 28252,
	"./sw.json": 34319,
	"./ta.json": 77610,
	"./te.json": 63718,
	"./th.json": 67549,
	"./tl.json": 21897,
	"./tr.json": 79755,
	"./uk.json": 92749,
	"./ur.json": 11946,
	"./uz.json": 17906,
	"./vi.json": 91496,
	"./yo.json": 30013,
	"./zh-cn.json": 22651,
	"./zh-tw.json": 71587
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89628;